import { render, staticRenderFns } from "./store-notify.vue?vue&type=template&id=7ed8d1bf&"
import script from "./store-notify.vue?vue&type=script&lang=js&"
export * from "./store-notify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports